import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { IPanelProps, IPanelStyleProps, IPanelStyles } from '/druid/Panel.types';
import { PanelBase } from '/druid/Panel.base';
import { getStyles } from '/druid/Panel.styles';

/**
 * Panel description
 */
export const Panel: React.FunctionComponent<IPanelProps> = styled<IPanelProps, IPanelStyleProps, IPanelStyles>(
  PanelBase,
  getStyles,
  undefined,
  {
    scope: 'Panel',
  },
);
